import { Formik } from "formik";
import { useDispatch } from "react-redux";
import ErrorMessage from "../../../form/ErrorMessage";
import PdfOrImageUploader from "../../../pdfImage uploader";
import { createContentSchema } from "../../../../utils/schema";
import {
  createContent,
  fetchContent,
} from "../../../../redux/features/coach/actions/coachAction";

const CreateContentModal = ({ onClose }) => {
  const dispatch = useDispatch();

  const initialValues = {
    files: null,
    image: null,
    title: "",
    content_type: "",
    visibility: "",
    status: "",
    short_description: "",
  };

  const hanldeCreateContent = (values) => {
    const callback = (response) => {
      dispatch(fetchContent());
      onClose();
    };
    const formData = new FormData();
    formData.append("title", values?.title?.trim());
    formData.append("content_type", values?.content_type);
    formData.append("visibility", values?.visibility);
    formData.append("status", values?.status);
    formData.append("short_description", values?.short_description?.trim());
    formData.append("image", values?.image[0]);
    (values.files || [])
      .filter((file) => file instanceof File)
      .forEach((file) => {
        formData.append("files", file);
      });

    dispatch(createContent({ payload: formData, callback }));
  };

  return (
    <div
      className="modal d-block ct_congratulation_modal_fade ct_reactivate_account"
      tabIndex="-1"
    >
      <div
        class="modal-dialog modal-dialog-centered ct_modal-dialog"
        style={{ maxWidth: "600px" }}
      >
        <div class="modal-content">
          <div className="modal-header border-0">
            <h4 className="ct_fs_16 ct_darkblue_text mb-0">Create Content</h4>
            <button
              type="button"
              className="btn-close ct_circle_close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body px-0 ct_mt_20 pt-0">
            <Formik
              initialValues={initialValues}
              validationSchema={createContentSchema}
              onSubmit={(values, actions) => {
                hanldeCreateContent(values);
              }}
              enableReinitialize
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setTouched,
              }) => (
                <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Title
                        </label>
                        <input
                          value={values?.title}
                          id="title"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          className="form-control ct_fs_12 ct_input"
                          placeholder=" e.g. Design Fundamentals for Beginners"
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"title"}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Content Type
                        </label>
                        <select
                          className="form-control ct_fs_12 ct_input"
                          value={values?.content_type}
                          id="content_type"
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option value="">Select Content Type</option>
                          <option value="eBook">eBook</option>
                          <option value="Guide">Guide</option>
                          <option value="Workbook">Workbook</option>
                          <option value="Media">Media</option>
                          <option value="Presentation">Presentation</option>
                          <option value="Integration">Integration</option>
                          <option value="Recording">Recording</option>
                        </select>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"content_type"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Visibility
                        </label>
                        <select
                          className="form-control ct_fs_12 ct_input"
                          value={values?.visibility}
                          id="visibility"
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option value={""}> Select Visibility</option>
                          <option value={"Public"}>Public </option>
                          <option value={"Private"}>Private </option>
                          <option value={"Restricted"}>Restricted </option>
                        </select>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"visibility"}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Status
                        </label>
                        <select
                          className="form-control ct_fs_12 ct_input"
                          value={values?.status}
                          id="status"
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option value={""}> Select Status</option>
                          <option value={"Draft"}>Draft </option>
                          <option value={"Published"}>Published </option>
                          <option value={"Archived"}>Archived </option>
                        </select>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"status"}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Short Description
                        </label>
                        <textarea
                          value={values?.short_description}
                          id="short_description"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          className="form-control ct_input h-auto ct_fs_12"
                          rows={4}
                          placeholder="Input short summary of the content"
                        ></textarea>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"short_description"}
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group mb-4">
                        <label class="mb-2 d-block ct_darkblue_text ct_fs_14">
                          Thumbnail Image{" "}
                        </label>
                        <PdfOrImageUploader
                          maxFiles={1}
                          multiple={true}
                          acceptType="application/pdf,image/*"
                          placeholder="Thumbnail Image (PDF or Image)"
                          existingFiles={
                            values?.image && Array.isArray(values.image)
                              ? values.image.map((file, idx) => {
                                  const isString = typeof file === "string";
                                  const isFileObj = file instanceof File;
                                  return {
                                    id: idx,
                                    file: isString
                                      ? file
                                      : file.preview
                                      ? file.preview
                                      : URL.createObjectURL(file),
                                    name: file.name || `image-${idx}`,
                                    type: isString
                                      ? file.endsWith(".pdf")
                                        ? "pdf"
                                        : "image"
                                      : file.type?.includes("pdf")
                                      ? "pdf"
                                      : file.type?.includes("zip")
                                      ? "zip"
                                      : "image",
                                    preview: file.preview || null,
                                    isExisting: true,
                                  };
                                })
                              : []
                          }
                          onChange={(newFiles) => {
                            setTouched({ image: true });
                            setFieldValue("image", newFiles);
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"image"}
                        />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group mb-4">
                        <label class="mb-2 d-block ct_darkblue_text ct_fs_14">
                          Upload File{" "}
                        </label>
                        <PdfOrImageUploader
                          maxFiles={20}
                          multiple={true}
                          acceptType="application/pdf,image/*"
                          placeholder="Upload File (PDF or Image)"
                          existingFiles={
                            values?.files && Array.isArray(values.files)
                              ? values.files.map((file, idx) => {
                                  const isString = typeof file === "string";
                                  const isFileObj = file instanceof File;

                                  return {
                                    id: idx,
                                    file: isString
                                      ? file
                                      : file.preview
                                      ? file.preview
                                      : URL.createObjectURL(file),

                                    name: file.name || `files-${idx}`,

                                    // Detect type correctly
                                    type: isString
                                      ? file.endsWith(".pdf")
                                        ? "pdf"
                                        : "image"
                                      : file.type?.includes("pdf")
                                      ? "pdf"
                                      : file.type?.includes("zip")
                                      ? "zip"
                                      : "image",

                                    preview: file.preview || null, // 🔥 keep preview if exists
                                    isExisting: true,
                                  };
                                })
                              : []
                          }
                          onChange={(newFiles) => {
                            setTouched({ files: true });
                            setFieldValue("files", newFiles); // store array of files
                          }}
                        />

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"files"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                    <button
                      className="ct_sky_blue_btn ct_fs_14 ct_yellow_btn ct_outline_grey  px-5 py-2"
                      style={{ borderColorL: "#53586252" }}
                      type="button"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className=" ct_yellow_btn px-5 ct_fs_14 py-2"
                      type="button"
                    >
                      Continue
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateContentModal;
